/* Compare-at prices in the cart drawer.
   theme.js redraws the drawer lines from /cart.js, which carries no compare-at prices. After every redraw this
   asks Shopify for sections/cart-compare.liquid (Section Rendering API), which renders the struck prices and the
   saving with the market's currency, and drops them into the lines and the footer. Nothing is formatted here. */
(function () {
  var drawer = document.querySelector('.cart-drawer');
  if (!drawer || !window.fetch) return;
  var items = drawer.querySelector('.cart-drawer__items');
  var foot = drawer.querySelector('.cart-drawer__foot');
  if (!items) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var seq = 0, timer = null;

  function apply(html) {
    var box = document.createElement('div');
    box.innerHTML = html;
    Array.prototype.forEach.call(items.querySelectorAll('.cart-line'), function (line) {
      var price = line.querySelector('.cart-line__price');
      if (!price) return;
      var old = price.querySelector('.cart-line__was');
      if (old) old.remove();
      var key = line.getAttribute('data-key');
      var tpl = null;
      Array.prototype.some.call(box.querySelectorAll('template[data-cc-line]'), function (t) {
        if (t.getAttribute('data-cc-line') === key) { tpl = t; return true; }
        return false;
      });
      if (!tpl) return;
      price.insertBefore(tpl.content.cloneNode(true), price.firstChild);
      price.classList.add('has-was');
    });
    if (!foot) return;
    var row = foot.querySelector('.cart-save');
    var save = box.querySelector('template[data-cc-save]');
    if (!save) { if (row) row.remove(); return; }
    if (!row) {
      row = document.createElement('div');
      row.className = 'cart-save';
      var total = foot.querySelector('.cart-total');
      foot.insertBefore(row, total || foot.firstChild);
    }
    row.innerHTML = '';
    row.appendChild(save.content.cloneNode(true));
  }

  function refresh() {
    var mine = ++seq;
    fetch(root + '?sections=cart-compare', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) { if (json && mine === seq && json['cart-compare'] != null) apply(json['cart-compare']); })
      .catch(function () {});
  }
  function soon() { clearTimeout(timer); timer = setTimeout(refresh, 60); }

  // theme.js swaps the whole list (childList on the list itself); our own insertions are deeper and do not retrigger.
  if ('MutationObserver' in window) new MutationObserver(soon).observe(items, { childList: true });
  if (items.querySelector('.cart-line')) refresh();
})();
